import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-navigation-logo')
export class NavigationLogo extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      .navigation__logo {
        display: block;
        height: 20px;
        width: 170px;
      }

      .navigation__logo img {
        display: block;
        height: 100%;
        object-fit: contain;
        object-position: left;
        width: 100%;
      }

      @media only screen and (min-width: 1175px){
        .navigation__logo {
          height: 40px;
          width: 172px;
        }
      }
    `];

  @property()
  link: string;
  @property()
  src: string;
  @property()
  alt: string;

  protected render(): unknown {
    return html`
      ${this.link ? html`
        <a class="navigation__logo" href="${this.link}">
          <img part="img"  src="${this.src}" alt="${this.alt}" width="180" loading="lazy">
        </a>
      ` : html`
        <picture class="navigation__logo">
          <img part="img" src="${this.src}" alt="${this.alt}" width="180" loading="lazy">
        </picture>
      `}
    `
  }
}
